module.exports = __webpack_public_path__ + "img/login-banner.76e0d98c.png";